
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL = "https://dev.mtlexpress.com.mm/mtl-shop-backend";//"http://localhost:8080/qq-delivery-backend";//
}

export default Resources;